import React from 'react';

import { dashboardConfig } from 'config/routeConfigurations/dashboardConfig/dashboardConfig';
import { Link as RouterLink } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import useEventWithDimensions from 'hooks/useEventWithDimensions';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { reportingConfig } from 'components/Dashboards/Reporting/reportingConfig';
import { Button } from 'components/DesignSystem/Button';

import classes from './ReportingHomePageHeader.module.scss';

export const ReportingHomePageHeader = () => {
    const { sendEventWithDimensions } = useEventWithDimensions();

    const handleCreateReportClick = (): void => {
        sendEventWithDimensions({
            category: 'Reporting',
            action: 'Create Flow Started',
            label: 'none',
        });
    };

    return (
        <BottomHeaderSection>
            <div className={classes.reportingHomePageHeader}>
                <ProgramTopHeader pageTitle={reportingConfig.reporting.title} />
                <Button
                    component={RouterLink}
                    to={AppRoutes.buildPath(
                        AppRoutes.DASHBOARD,
                        dashboardConfig.reporting.link,
                        reportingConfig.create.link,
                    )}
                    onClick={handleCreateReportClick}
                    startIcon={<MuiIcon icon={'add'} color={'var(--button-primary-fg)'} />}
                >
                    Create report
                </Button>
            </div>
        </BottomHeaderSection>
    );
};
